import { VeltCommentTool, VeltComments, VeltNotificationsTool } from '@veltdev/react';
import './NotificationsPage.css';

function NotificationsPage() {

    return (
        <div id="huddleContainer">
            <div className="huddle-main-view">
                <div className='huddle-tools-container'>
                    <VeltNotificationsTool/>
                    <VeltCommentTool/>
                    <VeltComments/>
                </div>
            </div>
        </div>
    )
}

export default NotificationsPage;